<div>
  <div class="popup-header">
    <h2 class="popup-title">References</h2>
    <span (click)="close()" class="close-button">
      <mat-icon aria-label="Close">close</mat-icon>
    </span>
  </div>

  <div class="popup-content">
    <ul class="mt-2">
      <li
        *ngFor="let reference of data.reference_number.split(',')"
        class="reference-item"
      >
        <span>
          {{ reference.trim() }}
        </span>
      </li>
    </ul>
  </div>
</div>
